import React, { useContext, useState, useEffect } from "react";
import { AppContext } from "../../contexts/AppContext";
import { UrlContext } from "../../contexts/UrlContext";
import Swal from "sweetalert2";

export default function DatabasePopupList({ projectID, setOpenSearch }) {
  const { searchData, setSearchData } = useContext(AppContext);
  const { API_URL } = useContext(UrlContext);
  const [isVarified, setIsVarified] = useState(true);
  const [uniqueID, setUniqueID] = useState([]);
  const [verifiedID, setVerifiedID] = useState([]);
  const [smartFilterID, setSmartFilterID] = useState([]);
  const [profileTypeID, setProfileTypeID] = useState([]);
  const [regionID, setRegionID] = useState([]);
  const [countryID, setCountryID] = useState([]);
  const [rateID, setRateID] = useState([]);
  const [loading, setLoading] = useState(false);

  const [expertRate, setExpertRate] = useState("");
  const [rateType, setRateType] = useState("hourly");
  const [isRateInputFocused, setIsRateInputFocused] = useState(false);
  const [includeNullRate, setIncludeNullRate] = useState(true);

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    console.log("event name: ", name);
    console.log("event Value: ", value);
    setSearchData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleCompanyType = (value) => {
    setSearchData((prevData) => ({
      ...prevData,
      companyType: value,
    }));
  };

  const updateingData = async (btn) => {
    localStorage.setItem(
      "searchData",
      JSON.stringify({
        ...searchData,
        project_id: projectID,
        buttonClicked: btn,
        isVarified: isVarified,
        searchingFrom: "cList",
        profileIDList: uniqueID,
      })
    );
  };

  const handleVarified = (value) => {
    setIsVarified(value);
  };

  const handleOpenSearch = async (btnSelected) => {
    await updateingData(btnSelected);
    console.log("Search data from submit: ", searchData);
    if (uniqueID.length === 0) {
      Swal.fire({
        title: "No profiles found!",
        text: "Please adjust your search criteria and try again.",
        icon: "warning",
        confirmButtonText: "OK",
      });
    } else {
      window.open(`/app/SearchDatabaseFromList/${projectID}`, "_blank");
    }
  };

  useEffect(() => {
    const fetchVarifiedProfileID = async () => {
      await getVarifiedProfileID();
      await updateUniqueID();
    };
    fetchVarifiedProfileID();
  }, [isVarified]);

  useEffect(() => {
    console.log("update function is running");
    if (smartFilterID.length > 0 || profileTypeID.length > 0 || regionID.length > 0 || countryID.length > 0 || verifiedID.length > 0 || rateID.length > 0) {
      const calculateUniqueID = async () => {
        await updateUniqueID();
      };
      calculateUniqueID();
      console.log("update function is running from inside");
    }
  }, [isVarified, verifiedID, smartFilterID, profileTypeID, regionID, countryID, rateID]);

  // Update unique ID based on the intersection of all the lists
  const updateUniqueID = async () => {
    const lists = [verifiedID, smartFilterID, profileTypeID, regionID, countryID, rateID];
    const nonEmptyLists = lists.filter(list => list.length > 0);

    if (nonEmptyLists.length === 0) {
      setUniqueID([]);
    } else if (nonEmptyLists.length === 1) {
      setUniqueID(nonEmptyLists[0]);
    } else {
      const intersection = nonEmptyLists.reduce((accumulator, currentList) =>
        accumulator.filter(id => currentList.includes(id)));

      setUniqueID([...intersection]);
    }
  };

  // Api for getting verified profile ID
  const getVarifiedProfileID = async () => {
    setLoading(true);
    const requestBody = {
      isVarified: isVarified,
    };
    try {
      let modifiedUrl = "get-varified-experts";
      const response = await fetch(`${API_URL}${modifiedUrl}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody),
      });
      const responseData = await response.json();
      if (responseData.status === "success") {
        setVerifiedID(responseData.expertIDList);
      } else {
        console.error("Failed to get verified profile ID");
      }
    } catch (error) {
      console.error("Error while calling the backend API:", error);
    }
    setLoading(false);
  };

  // Api for getting smart filter profile ID
  const getSmartFilterID = async () => {
    setLoading(true);
    setCountryID([]);
    setRegionID([]);
    setProfileTypeID([]);

    setSearchData((prevData) => ({
      ...prevData,
      country: "",
      region: "",
      profile_type: "",
    }));

    const requestBody = {
      projectID: projectID,
      searchingFrom: "cList",
    };
    try {
      let modifiedUrl = "get-expert-with-smartFilter";
      const response = await fetch(`${API_URL}${modifiedUrl}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody),
      });
      const responseData = await response.json();
      if (responseData.status === "success") {
        setSmartFilterID(responseData.expertIDList);
      } else {
        console.error("Failed to get smartFilter profile ID");
      }
    } catch (error) {
      console.error("Error while calling the backend API:", error);
    }
    setLoading(false);
  };

  // Api for getting profile type ID
  const getExpertWithProfileType = async (selectedType) => {
    setLoading(true);
    const requestBody = {
      profileType: selectedType,
    };
    try {
      let modifiedUrl = "get-expert-with-profileType";
      const response = await fetch(`${API_URL}${modifiedUrl}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody),
      });
      const responseData = await response.json();
      if (responseData.status === "success") {
        setProfileTypeID(responseData.expertIDList);
      } else {
        console.error("Failed to get profile type ID");
      }
    } catch (error) {
      console.error("Error while calling the backend API:", error);
    }
    setLoading(false);
  };

  // Api for getting country filter profile ID
  const getExpertWithCountry = async (country) => {
    setLoading(true);
    const requestBody = {
      country: country,
    };
    try {
      let modifiedUrl = "get-expert-with-country";
      const response = await fetch(`${API_URL}${modifiedUrl}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody),
      });
      const responseData = await response.json();
      if (responseData.status === "success") {
        setCountryID(responseData.expertIDList);
      } else {
        console.error("Failed to get country filter profile ID");
      }
    } catch (error) {
      console.error("Error while calling the backend API:", error);
    }
    setLoading(false);
  };

  // Api for getting region filter profile ID
  const getExpertWithRegion = async (region) => {
    setLoading(true);
    const requestBody = {
      region: region,
    };
    try {
      let modifiedUrl = "get-expert-with-region";
      const response = await fetch(`${API_URL}${modifiedUrl}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody),
      });
      const responseData = await response.json();
      if (responseData.status === "success") {
        setRegionID(responseData.expertIDList);
      } else {
        console.error("Failed to get gegion filter profile ID");
      }
    } catch (error) {
      console.error("Error while calling the backend API:", error);
    }
    setLoading(false);
  };

  // Api for getting expert rate filter profile ID
  const getExpertWithRate = async (rate, type, nullRate) => {
    setLoading(true);
    if (rate) {
      const requestBody = {
        amount: rate,
        rateType: type,
        includeNullRate: nullRate,
      };
      try {
        let modifiedUrl = "get-expert-with-rating";
        const response = await fetch(`${API_URL}${modifiedUrl}`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestBody),
        });
        const responseData = await response.json();
        if (responseData.status === "success") {
          setRateID(responseData.expertIDList);
        } else {
          console.error("Failed to get expert rate filter profile ID");
        }
      } catch (error) {
        console.error("Error while calling the backend API:", error);
      }
    } else {
      setRateID([]);
    }
    setLoading(false);
  };

  return (
    <>
      <div className="decline-wrapper">
        <div className="flex-container-decline-profile" style={{padding: "0px", width: "60%", height: "50%"}}>
          <div className="flex-item-decline-profile-header" style={{flex: "5%", backgroundColor: "#365561"}}>
            <div style={{display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center", gap: "10px"}}>
              <p style={{fontSize: "16px", fontWeight: "500", marginLeft: "5px", color: "white"}}>Database search</p>
              <p style={{fontSize: "16px", color: "white"}}>|</p>
              <p style={{fontSize: "13px", color: "white"}}>Relevant profile found: {uniqueID.length}</p>
            </div>
            <i 
              class="fa-solid fa-xmark" 
              style={{
                marginRight: "5px", 
                marginTop: "3px", 
                color: "gray", 
                cursor: "pointer"
              }}
              onClick={() => {
                setOpenSearch(false); 
                setSearchData({
                  ...searchData,
                  profile_type: "",
                  search_type: "entireDatabase",
                  position: "",
                  region: "",
                  country: "",
                  keywords: "",
                  company: "",
                  more_profiles: "",
                  project_id: "",
                  buttonClicked: "",
                  companyType: "both",
                  searchingFrom: "",
                  profileIDList: [],
                });
              }}
            />
          </div>

          <div className="flex-item-dicline-profile" style={{flex: "90%", display: "flex", flexDirection: "row", overflowY: "auto", padding: "10px", justifyContent: "center", alignItems: "center"}}>
            <div
              className="flex-container-database-popUp-content-container"
              style={{ display: "flex", flexDirection: "column", gap: "10px", justifyContent: "center", alignItems: "center", width: "100%", opacity: loading ? "0.5" : "1"}}
            >
              <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-start", width: "100%" }}>
                <div className="flex-item-new-event-content-div-left-div-item">
                  <div class="custom-control custom-control-right custom-switch">
                    <input
                      type="checkbox"
                      class="custom-control-input"
                      id="customSwitch-for-new-event-auto-record"
                      checked={isVarified}
                      onChange={(e) => {
                        handleVarified(e.target.checked);
                      }}
                    />
                    <label class="custom-control-label" for="customSwitch-for-new-event-auto-record">Only verified profiles?</label>
                    {isVarified ? (
                      <label class="emailReminderLabel" style={{marginLeft: '45px', fontWeight: 'bold'}}>ON!</label>
                    ):(
                      <label class="emailReminderLabel" style={{marginLeft: '45px', fontWeight: 'bold'}} >OFF!</label>
                    )}
                  </div>
                </div>
              </div>

              <div className="flex-container-database-popUp-content-item" style={{width: "100%", pointerEvents: isRateInputFocused ? "none" : "auto", opacity: isRateInputFocused ? "0.5" : "1"}}>
                <div className="flex-container-database-popUp-content-item-container" style={{ display: "flex", flexDirection: "row", gap: "10px" }}>
                  <div className="flex-container-database-popUp-content-item-container-item" style={{ flex: "50%" }}>
                    <select
                      className="form-control"
                      name="search_type"
                      onChange={(e) => {handleInputChange(e); {e.target.value === "smartFilter" ? getSmartFilterID() : setSmartFilterID([])}}}
                      value={searchData.search_type}
                      disabled={loading}
                    >
                      <option value="smartFilter">Smart Filter</option>
                      <option value="entireDatabase">Entire Database</option>
                    </select>
                  </div>
                  <div className="flex-container-database-popUp-content-item-container-item" style={{ flex: "50%", width: "100%" }}>
                    <select
                      className="form-control"
                      name="profile_type"
                      onChange={(e) => {handleInputChange(e); {e.target.value !== "" ? getExpertWithProfileType(e.target.value) : setProfileTypeID([])}}}
                      value={searchData.profile_type}
                      disabled={searchData.search_type === "smartFilter" || loading}
                    >
                      <option value="">Select Profile Type</option>
                      <option value="con">Consultants</option>
                      <option value="exp">Experts</option>
                    </select>
                  </div>
                </div>
              </div>

              <div className="flex-container-database-popUp-content-item" style={{width: "100%", pointerEvents: isRateInputFocused ? "none" : "auto", opacity: isRateInputFocused ? "0.5" : "1"}}>
                <div
                  className="flex-container-database-popUp-content-item-container"
                  style={{ display: "flex", flexDirection: "row", gap: "10px" }}
                >
                  <div
                    className="flex-container-database-popUp-content-item-container-item"
                    style={{ flex: "50%" }}
                  >
                    <select
                      className="form-control"
                      name="region"
                      onChange={(e) => {handleInputChange(e); {e.target.value !== "" ? getExpertWithRegion(e.target.value) : setRegionID([])}}}
                      value={searchData.region}
                      disabled={searchData.country !== "" || searchData.search_type === "smartFilter" || loading}
                    >
                      <option value="" selected>
                        Select Region
                      </option>
                      <option value="Europe">Europe</option>
                      <option value="Middle East">Middle East</option>
                      <option value="Asia Pacific">Asia Pacific</option>
                      <option value="Africa">Africa</option>
                      <option value="Latin America">Latin America</option>
                      <option value="North America">North America</option>
                      <option value="DACH">DACH</option>
                    </select>
                  </div>
                  <div
                    className="flex-container-database-popUp-content-item-container-item"
                    style={{ flex: "50%" }}
                  >
                    <select
                      className="form-control"
                      name="country"
                      onChange={(e) => {handleInputChange(e); {e.target.value !== "" ? getExpertWithCountry(e.target.value) : setCountryID([])}}}
                      value={searchData.country}
                      disabled={searchData.region !== "" || searchData.search_type === "smartFilter" || loading}
                    >
                      <option value="">Select Country</option>
                      <option value="Afghanistan">Afghanistan</option>
                      <option value="Åland Islands">Åland Islands</option>
                      <option value="Albania">Albania</option>
                      <option value="Algeria">Algeria</option>
                      <option value="American Samoa">American Samoa</option>
                      <option value="Andorra">Andorra</option>
                      <option value="Angola">Angola</option>
                      <option value="Anguilla">Anguilla</option>
                      <option value="Antarctica">Antarctica</option>
                      <option value="Antigua and Barbuda">
                        Antigua and Barbuda
                      </option>
                      <option value="Argentina">Argentina</option>
                      <option value="Armenia">Armenia</option>
                      <option value="Aruba">Aruba</option>
                      <option value="Australia">Australia</option>
                      <option value="Austria">Austria</option>
                      <option value="Azerbaijan">Azerbaijan</option>
                      <option value="Bahamas">Bahamas</option>
                      <option value="Bahrain">Bahrain</option>
                      <option value="Bangladesh">Bangladesh</option>
                      <option value="Barbados">Barbados</option>
                      <option value="Belarus">Belarus</option>
                      <option value="Belgium">Belgium</option>
                      <option value="Belize">Belize</option>
                      <option value="Benin">Benin</option>
                      <option value="Bermuda">Bermuda</option>
                      <option value="Bhutan">Bhutan</option>
                      <option value="Bolivia">Bolivia</option>
                      <option value="Bosnia and Herzegovina">
                        Bosnia and Herzegovina
                      </option>
                      <option value="Botswana">Botswana</option>
                      <option value="Bouvet Island">Bouvet Island</option>
                      <option value="Brazil">Brazil</option>
                      <option value="British Indian Ocean Territory">
                        British Indian Ocean Territory
                      </option>
                      <option value="Brunei Darussalam">
                        Brunei Darussalam
                      </option>
                      <option value="Bulgaria">Bulgaria</option>
                      <option value="Burkina Faso">Burkina Faso</option>
                      <option value="Burundi">Burundi</option>
                      <option value="Cambodia">Cambodia</option>
                      <option value="Cameroon">Cameroon</option>
                      <option value="Canada">Canada</option>
                      <option value="Cape Verde">Cape Verde</option>
                      <option value="Cayman Islands">Cayman Islands</option>
                      <option value="Central African Republic">
                        Central African Republic
                      </option>
                      <option value="Chad">Chad</option>
                      <option value="Chile">Chile</option>
                      <option value="China">China</option>
                      <option value="Christmas Island">Christmas Island</option>
                      <option value="Cocos (Keeling) Islands">
                        Cocos (Keeling) Islands
                      </option>
                      <option value="Colombia">Colombia</option>
                      <option value="Comoros">Comoros</option>
                      <option value="Congo">Congo</option>
                      <option value="Congo, The Democratic Republic of The">
                        Congo, The Democratic Republic of The
                      </option>
                      <option value="Cook Islands">Cook Islands</option>
                      <option value="Costa Rica">Costa Rica</option>
                      <option value="Cote D'ivoire">Cote D'ivoire</option>
                      <option value="Croatia">Croatia</option>
                      <option value="Cuba">Cuba</option>
                      <option value="Cyprus">Cyprus</option>
                      <option value="Czech Republic">Czech Republic</option>
                      <option value="Denmark">Denmark</option>
                      <option value="Djibouti">Djibouti</option>
                      <option value="Dominica">Dominica</option>
                      <option value="Dominican Republic">
                        Dominican Republic
                      </option>
                      <option value="Ecuador">Ecuador</option>
                      <option value="Egypt">Egypt</option>
                      <option value="El Salvador">El Salvador</option>
                      <option value="Equatorial Guinea">
                        Equatorial Guinea
                      </option>
                      <option value="Eritrea">Eritrea</option>
                      <option value="Estonia">Estonia</option>
                      <option value="Ethiopia">Ethiopia</option>
                      <option value="Falkland Islands (Malvinas)">
                        Malvinas
                      </option>
                      <option value="Faroe Islands">Faroe Islands</option>
                      <option value="Fiji">Fiji</option>
                      <option value="Finland">Finland</option>
                      <option value="France">France</option>
                      <option value="French Guiana">French Guiana</option>
                      <option value="French Polynesia">French Polynesia</option>
                      <option value="French Southern Territories">
                        French Southern Territories
                      </option>
                      <option value="Gabon">Gabon</option>
                      <option value="Gambia">Gambia</option>
                      <option value="Georgia">Georgia</option>
                      <option value="Germany">Germany</option>
                      <option value="Ghana">Ghana</option>
                      <option value="Gibraltar">Gibraltar</option>
                      <option value="Greece">Greece</option>
                      <option value="Greenland">Greenland</option>
                      <option value="Grenada">Grenada</option>
                      <option value="Guadeloupe">Guadeloupe</option>
                      <option value="Guam">Guam</option>
                      <option value="Guatemala">Guatemala</option>
                      <option value="Guernsey">Guernsey</option>
                      <option value="Guinea">Guinea</option>
                      <option value="Guinea-bissau">Guinea-bissau</option>
                      <option value="Guyana">Guyana</option>
                      <option value="Haiti">Haiti</option>
                      <option value="Heard Island and Mcdonald Islands">
                        Heard Island and Mcdonald Islands
                      </option>
                      <option value="Holy See (Vatican City State)">
                        Holy See (Vatican City State)
                      </option>
                      <option value="Honduras">Honduras</option>
                      <option value="Hong Kong">Hong Kong</option>
                      <option value="Hungary">Hungary</option>
                      <option value="Iceland">Iceland</option>
                      <option value="India">India</option>
                      <option value="Indonesia">Indonesia</option>
                      <option value="Iran, Islamic Republic of">
                        Iran, Islamic Republic of
                      </option>
                      <option value="Iraq">Iraq</option>
                      <option value="Ireland">Ireland</option>
                      <option value="Isle of Man">Isle of Man</option>
                      <option value="Israel">Israel</option>
                      <option value="Italy">Italy</option>
                      <option value="Jamaica">Jamaica</option>
                      <option value="Japan">Japan</option>
                      <option value="Jersey">Jersey</option>
                      <option value="Jordan">Jordan</option>
                      <option value="Kazakhstan">Kazakhstan</option>
                      <option value="Kenya">Kenya</option>
                      <option value="Kiribati">Kiribati</option>
                      <option value="Korea, Democratic People's Republic of">
                        Korea, Democratic People's Republic of
                      </option>
                      <option value="Korea, Republic of">
                        Korea, Republic of
                      </option>
                      <option value="Kuwait">Kuwait</option>
                      <option value="Kyrgyzstan">Kyrgyzstan</option>
                      <option value="Lao People's Democratic Republic">
                        Lao People's Democratic Republic
                      </option>
                      <option value="Latvia">Latvia</option>
                      <option value="Lebanon">Lebanon</option>
                      <option value="Lesotho">Lesotho</option>
                      <option value="Liberia">Liberia</option>
                      <option value="Libyan Arab Jamahiriya">
                        Libyan Arab Jamahiriya
                      </option>
                      <option value="Liechtenstein">Liechtenstein</option>
                      <option value="Lithuania">Lithuania</option>
                      <option value="Luxembourg">Luxembourg</option>
                      <option value="Macao">Macao</option>
                      <option value="Macedonia, The Former Yugoslav Republic of">
                        Macedonia, The Former Yugoslav Republic of
                      </option>
                      <option value="Madagascar">Madagascar</option>
                      <option value="Malawi">Malawi</option>
                      <option value="Malaysia">Malaysia</option>
                      <option value="Maldives">Maldives</option>
                      <option value="Mali">Mali</option>
                      <option value="Malta">Malta</option>
                      <option value="Marshall Islands">Marshall Islands</option>
                      <option value="Martinique">Martinique</option>
                      <option value="Mauritania">Mauritania</option>
                      <option value="Mauritius">Mauritius</option>
                      <option value="Mayotte">Mayotte</option>
                      <option value="Mexico">Mexico</option>
                      <option value="Micronesia, Federated States of">
                        Micronesia, Federated States of
                      </option>
                      <option value="Moldova, Republic of">
                        Moldova, Republic of
                      </option>
                      <option value="Monaco">Monaco</option>
                      <option value="Mongolia">Mongolia</option>
                      <option value="Montenegro">Montenegro</option>
                      <option value="Montserrat">Montserrat</option>
                      <option value="Morocco">Morocco</option>
                      <option value="Mozambique">Mozambique</option>
                      <option value="Myanmar">Myanmar</option>
                      <option value="Namibia">Namibia</option>
                      <option value="Nauru">Nauru</option>
                      <option value="Nepal">Nepal</option>
                      <option value="Netherlands">Netherlands</option>
                      <option value="Netherlands Antilles">
                        Netherlands Antilles
                      </option>
                      <option value="New Caledonia">New Caledonia</option>
                      <option value="New Zealand">New Zealand</option>
                      <option value="Nicaragua">Nicaragua</option>
                      <option value="Niger">Niger</option>
                      <option value="Nigeria">Nigeria</option>
                      <option value="Niue">Niue</option>
                      <option value="Norfolk Island">Norfolk Island</option>
                      <option value="Northern Mariana Islands">
                        Northern Mariana Islands
                      </option>
                      <option value="Norway">Norway</option>
                      <option value="Oman">Oman</option>
                      <option value="Pakistan">Pakistan</option>
                      <option value="Palau">Palau</option>
                      <option value="Palestinian Territory, Occupied">
                        Palestinian Territory, Occupied
                      </option>
                      <option value="Panama">Panama</option>
                      <option value="Papua New Guinea">Papua New Guinea</option>
                      <option value="Paraguay">Paraguay</option>
                      <option value="Peru">Peru</option>
                      <option value="Philippines">Philippines</option>
                      <option value="Pitcairn">Pitcairn</option>
                      <option value="Poland">Poland</option>
                      <option value="Portugal">Portugal</option>
                      <option value="Puerto Rico">Puerto Rico</option>
                      <option value="Qatar">Qatar</option>
                      <option value="Reunion">Reunion</option>
                      <option value="Romania">Romania</option>
                      <option value="Russian Federation">
                        Russian Federation
                      </option>
                      <option value="Rwanda">Rwanda</option>
                      <option value="Saint Helena">Saint Helena</option>
                      <option value="Saint Kitts and Nevis">
                        Saint Kitts and Nevis
                      </option>
                      <option value="Saint Lucia">Saint Lucia</option>
                      <option value="Saint Pierre and Miquelon">
                        Saint Pierre and Miquelon
                      </option>
                      <option value="Saint Vincent and The Grenadines">
                        Saint Vincent and The Grenadines
                      </option>
                      <option value="Samoa">Samoa</option>
                      <option value="San Marino">San Marino</option>
                      <option value="Sao Tome and Principe">
                        Sao Tome and Principe
                      </option>
                      <option value="Saudi Arabia">Saudi Arabia</option>
                      <option value="Senegal">Senegal</option>
                      <option value="Serbia">Serbia</option>
                      <option value="Seychelles">Seychelles</option>
                      <option value="Sierra Leone">Sierra Leone</option>
                      <option value="Singapore">Singapore</option>
                      <option value="Slovakia">Slovakia</option>
                      <option value="Slovenia">Slovenia</option>
                      <option value="Solomon Islands">Solomon Islands</option>
                      <option value="Somalia">Somalia</option>
                      <option value="South Africa">South Africa</option>
                      <option value="South Georgia and The South Sandwich Islands">
                        South Georgia and The South Sandwich Islands
                      </option>
                      <option value="Spain">Spain</option>
                      <option value="Sri Lanka">Sri Lanka</option>
                      <option value="Sudan">Sudan</option>
                      <option value="Suriname">Suriname</option>
                      <option value="Svalbard and Jan Mayen">
                        Svalbard and Jan Mayen
                      </option>
                      <option value="Swaziland">Swaziland</option>
                      <option value="Sweden">Sweden</option>
                      <option value="Switzerland">Switzerland</option>
                      <option value="Syrian Arab Republic">
                        Syrian Arab Republic
                      </option>
                      <option value="Taiwan, Province of China">
                        Taiwan, Province of China
                      </option>
                      <option value="Tajikistan">Tajikistan</option>
                      <option value="Tanzania, United Republic of">
                        Tanzania, United Republic of
                      </option>
                      <option value="Thailand">Thailand</option>
                      <option value="Timor-leste">Timor-leste</option>
                      <option value="Togo">Togo</option>
                      <option value="Tokelau">Tokelau</option>
                      <option value="Tonga">Tonga</option>
                      <option value="Trinidad and Tobago">
                        Trinidad and Tobago
                      </option>
                      <option value="Tunisia">Tunisia</option>
                      <option value="Turkey">Turkey</option>
                      <option value="Turkmenistan">Turkmenistan</option>
                      <option value="Turks and Caicos Islands">
                        Turks and Caicos Islands
                      </option>
                      <option value="Tuvalu">Tuvalu</option>
                      <option value="Uganda">Uganda</option>
                      <option value="Ukraine">Ukraine</option>
                      <option value="United Arab Emirates">
                        United Arab Emirates
                      </option>
                      <option value="United Kingdom">United Kingdom</option>
                      <option value="United States">United States</option>
                      <option value="United States Minor Outlying Islands">
                        United States Minor Outlying Islands
                      </option>
                      <option value="Uruguay">Uruguay</option>
                      <option value="Uzbekistan">Uzbekistan</option>
                      <option value="Vanuatu">Vanuatu</option>
                      <option value="Venezuela">Venezuela</option>
                      <option value="Viet Nam">Viet Nam</option>
                      <option value="Virgin Islands, British">
                        Virgin Islands, British
                      </option>
                      <option value="Virgin Islands, U.S.">
                        Virgin Islands, U.S.
                      </option>
                      <option value="Wallis and Futuna">
                        Wallis and Futuna
                      </option>
                      <option value="Western Sahara">Western Sahara</option>
                      <option value="Yemen">Yemen</option>
                      <option value="Zambia">Zambia</option>
                      <option value="Zimbabwe">Zimbabwe</option>
                    </select>
                  </div>
                </div>
              </div>

              <div className="flex-container-database-popUp-content-item"  style={{width: "100%"}}>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    border: "1px solid lightgrey",
                    borderRadius: "5px"
                  }}
                >
                  <div style={{flex: "95%", width: "100%", pointerEvents: isRateInputFocused ? "none" : "auto", opacity: isRateInputFocused ? "0.5" : "1"}} onClick={() => setIsRateInputFocused(true)}>
                    {expertRate==="" ? (
                      <>
                        <p style={{padding: "5px", color: "grey"}}>Expert rate (Only numbers are allowed)</p>
                      </>
                    ):(
                      <>
                        {rateType === "hourly" ? <><p style={{padding: "5px", marginLeft: "10px"}}>{expertRate} per hour</p></> : <p style={{padding: "5px", marginLeft: "10px"}}>{expertRate} per day</p>}
                      </>
                    )}
                  </div>

                </div>
              </div>

              <div className="flex-container-database-popUp-content-item" style={{width: "100%", pointerEvents: isRateInputFocused ? "none" : "auto", opacity: isRateInputFocused ? "0.5" : "1"}}>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    border: "1px solid lightgrey",
                    borderRadius: "5px"
                  }}
                >
                  <div style={{flex: "95%", width: "100%"}}>
                    <input
                      className="form-control"
                      name="company"
                      placeholder="Company names (Boolean search option available; using quotation is recommended)"
                      onChange={(e) => handleInputChange(e)}
                      value={searchData.company}
                      style={{outline: "none", border: "none"}}
                    />
                  </div>

                  <div style={{flex: "5%", display: "flex", flexDirection: "row", justifyContent: "flex-end"}}>
                    <div className="accept-consultant-button tooltip-employment">
                      <select
                        className="company-working-period"
                        name="position_period"
                        onChange={(e) => handleCompanyType(e.target.value)}
                        value={searchData.companyType}
                      >
                        <option value="both">Both</option>
                        <option value="past">Past</option>
                        <option value="current">Current</option>
                      </select>
                      <span className="tooltip-text">employment period</span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="flex-container-database-popUp-content-item" style={{width: "100%", pointerEvents: isRateInputFocused ? "none" : "auto", opacity: isRateInputFocused ? "0.5" : "1"}}>
                <input
                  className="form-control"
                  name="keywords"
                  placeholder="Keywords (Boolean search option available)"
                  onChange={(e) => handleInputChange(e)}
                  value={searchData.keywords}
                />
              </div>
            </div>
            {loading && 
              <div className="loader" style={{position: "fixed", justifyContent: "center", alignItems: "center", display: "flex"}}>
                <i class="fa-solid fa-spinner fa-spin-pulse" style={{color: "#365561", fontSize: "100px"}}></i>
              </div>
            }
            {isRateInputFocused && 
              <>
                <div className="flex-container-database-popUp-content-item" 
                  style={{
                    display: "flex", 
                    flexDirection: "column",
                    height: "30%", 
                    width: "50%", 
                    position: "fixed", 
                    justifyContent: "center", 
                    alignItems: "center", 
                    backgroundColor: "white", 
                    zIndex: "100",
                    border: "1px solid lightgrey",
                    borderRadius: "5px"
                  }}
                >  
                  <div style={{flex: "5%", fontSize: "16px"}}>Expert Rate</div>
                  <div style={{flex: "90%", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center"}}>
                    
                    <div style={{display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", gap: "20px"}}>
                      <div style={{display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center", width: "100%"}}>
                        <input
                          className="form-control"
                          name="expertRate"
                          type="number"
                          placeholder="Amount (Only numbers)"
                          onChange={(e) => setExpertRate(e.target.value)}
                          value={expertRate}
                          style={{outline: "none", border: "1px solid lightgrey"}}
                        />

                        <div style={{flex: "5%", display: "flex", flexDirection: "row", justifyContent: "flex-end"}}>
                          <div className="accept-consultant-button tooltip-employment">
                            <select
                              className="company-working-period"
                              name="position_period"
                              onChange={(e) => {setRateType(e.target.value)}}
                              value={rateType}
                            >
                              <option value="hourly">Hourly</option>
                              <option value="daily">Daily</option>
                            </select>
                            <span className="tooltip-text">Rate type</span>
                          </div>
                        </div>
                      </div>

                      <div class="custom-control custom-control-right custom-switch">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="customSwitch-for-null-rate"
                          checked={includeNullRate}
                          onChange={(e) => {
                            setIncludeNullRate(e.target.checked);
                          }}
                        />
                        <label class="custom-control-label" for="customSwitch-for-null-rate">Include profiles with no rate information?</label>
                        {includeNullRate ? (
                          <label class="emailReminderLabel" style={{marginLeft: '45px', fontWeight: 'bold'}}>ON!</label>
                        ):(
                          <label class="emailReminderLabel" style={{marginLeft: '45px', fontWeight: 'bold'}} >OFF!</label>
                        )}
                      </div>
                    </div>

                  </div>
                  <div style={{flex: "5%", display: "flex", flexDirection: "row", justifyContent: "center", gap: "10px"}}>
                    <button 
                      className="btn base-btn"
                      onClick={() => {setIsRateInputFocused(false); getExpertWithRate(expertRate, rateType, includeNullRate)}}
                    >
                      Done
                    </button>
                    {/* <button
                      className="btn btn-light"
                      style={{border: "1px solid lightgrey"}}
                      onClick={() => {setIsRateInputFocused(false); setExpertRate(""); setRateID([])}}
                    >
                      Cancle
                    </button> */}
                  </div>
                </div>
              </>
            }
          </div>

          <div className="flex-item-database-popUp-bottom" style={{flex: "5%", pointerEvents: isRateInputFocused ? "none" : "auto", opacity: isRateInputFocused ? "0.5" : "1"}}>
              <div
                className="flex-container-database-popUp-bottom-container"
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "center",
                  gap: "20px",
                  alignItems: "center",
                }}
              >
                <button
                  className="btn base-btn"
                  onClick={() => handleOpenSearch("HerokuSearch")}
                >
                  Database Search
                </button>
                <button
                  className="btn base-btn"
                  onClick={() => handleOpenSearch("ZohoSearch")}
                >
                  Zoho Search
                </button>
                <button
                  className="btn base-btn"
                  onClick={() => handleOpenSearch("GoogleSearch")}
                  disabled
                  style={{ cursor: "default" }}
                >
                  Google Search
                </button>
                <button
                  className="btn base-btn"
                  onClick={() => handleOpenSearch("SearchBoth")}
                  style={{ cursor: "default" }}
                  disabled
                >
                  Search Both
                </button>
              </div>
          </div>
        </div>
      </div>
    </>
  );
}
